// extracted by mini-css-extract-plugin
export var infoRow = "_mo-2";
export var labelContainer = "_mo-0";
export var rightInfo = "_mo-1";